export enum TaskType {
  ToDoTask = 1,
  OwnerTask = 2,
  ParticipateTask = 3,
  CCTask = 4,
}